<template>
  <div>
    <el-dialog
      class="dialog"
      title="堆箱信息"
      :close-on-click-modal="false"
      :show-close="false"
      :visible.sync="dialogVisible"
      width="550px"
    >
      <!-- 堆箱类型 -->
      <div class="stack-type">
        <div class="stack-title">堆箱类型</div>
        <div class="stack-radio">
          <el-radio
            v-model="stackType"
            label="01"
            @change="handleChangeStackType"
          >
            单品牌堆箱
          </el-radio>
        </div>
        <div class="stack-radio">
          <el-radio
            v-model="stackType"
            label="02"
            @change="handleChangeStackType"
          >
            混堆
          </el-radio>
        </div>
      </div>
      <div class="stack-info">
        <!-- 堆箱规格 -->
        <div class="stack-size">
          <div class="stack-title">堆箱规格</div>
          <div>
            <el-input
              v-model="row"
              placeholder="行"
              style="width:50px"
              onkeyup="value=value.replace(/[^\d]/g,'')"
              @input="handleChangeStackSize"
            >
            </el-input>
            <span> * </span>
            <el-input
              v-model="column"
              placeholder="列"
              style="width:50px"
              onkeyup="value=value.replace(/[^\d]/g,'')"
              @input="handleChangeStackSize"
            >
            </el-input>
          </div>
        </div>

        <!-- 品牌 -->
        <div class="stack-brand" v-show="stackType === '01'">
          <div class="stack-title">品牌</div>
          <div>
            <el-select
              v-model="brandCode"
              placeholder="选择品牌"
              filterable
              size="mini"
              @change="handleBrandChange"
            >
              <template v-for="item in brandList">
                <!-- 混堆设计时选择子品牌 不允许再选择‘混堆’ 因此剔除 -->
                <el-option
                  v-if="
                    item.abiBrandCode !== 'BUDHD'
                  "
                  :key="item.abiBrandId"
                  :label="item.abiBrandDesc"
                  :value="item.abiBrandCode"
                >
                </el-option>
              </template>
            </el-select>
          </div>
        </div>

        <div class="stack-brand" v-show="stackType === '01'">
          <div class="stack-title">子品牌</div>
          <div>
            <el-select
              v-model="subBrandCode"
              placeholder="选择子品牌"
              filterable
              size="mini"
            >
              <template v-for="item in getSubBrandListByCode">
                <el-option
                  v-if="
                    item.parentBrandCode !== 'BUDHD'
                  "
                  :key="item.abiBrandId"
                  :label="item.abiBrandDesc"
                  :value="item.abiBrandCode"
                >
                </el-option>
              </template>
            </el-select>
          </div>
        </div>

        <!-- 混堆 -->
        <div class="stack-design" v-show="stackType === '02'">
          <!-- 混堆设计图 -->
          <div class="stack-title">混堆设计图</div>

          <div v-if="brandSelectedMixing && brandSelectedMixing.length">
            <div
              class="design-thumbnail"
              title="查看详情"
            >
              <div
                class="design-thumbnail-column"
                v-for="(cItem, cIndex) in Number(column)"
                :key="cIndex"
              >
                <div
                  class="design-thumbnail-row"
                  v-for="(rItem, rIndex) in Number(row)"
                  :key="rIndex"
                  :style="`background:${getBrandColor(cIndex)}`"
                ></div>
              </div>
            </div>
          </div>

          <div>
            <el-button
              v-if="brandSelectedMixing && brandSelectedMixing.length"
              type="success"
              size="mini"
              plain
              @click="modifyDesignDiagram"
            >修改</el-button>
            <el-button
              v-else
              type="success"
              size="mini"
              plain
              @click="addDesignDiagram"
            >添加</el-button>
          </div>
        </div>
      </div>

      <!-- 混堆设计图弹窗 -->
      <el-dialog
        :title="`${row} * ${column}`"
        :close-on-click-modal="false"
        :show-close="false"
        :visible.sync="designDialogVisible"
        destroy-on-close
        center
        append-to-body
        width="550px"
      >
        <StackDesignConfig
          ref="StackDesignConfig"
          :row="row"
          :column="column"
          :brandSelected="brandSelectedMixing"
          :subBrandList="subBrandList"
          @handleCancelDesign="handleCancelDesign"
          @handleConfirmDesign="handleConfirmDesign"
        ></StackDesignConfig>
      </el-dialog>

      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCancel">取 消</el-button>
        <el-button type="danger" @click="handleConfirm">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import StackDesignConfig from './stack-design-config.vue'
export default {
  name: 'mixing-stack-config-dialog',
  components: {
    StackDesignConfig
  },
  props: {
    brandList: {
      type: Array,
      default: () => {
        return []
      }
    },
    dialogVisible: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    // stackType () {
    //   this.handleChangeStackSize()
    // }
  },
  computed: {
    // 根据父品牌code 找到对应子品牌list
    getSubBrandListByCode () {
      if (!this.brandCode || this.stackType !== '01') return
      let brandData
      if (this.stackType === '01' && this.brandCode) {
        this.brandList.forEach(item => {
          if (item.abiBrandCode === this.brandCode) brandData = item
        })
      }
      return brandData ? brandData.subBrandList : []
    }
  },
  data () {
    return {
      stackType: '01',
      row: '',
      column: '',

      brandCode: '', // 单堆品牌code
      subBrandCode: '', // 单堆子品牌code

      designDialogVisible: false,
      brandSelectedMixing: [], // 混堆品牌选择
      subBrandList: []
      // brandSelected: []

    }
  },
  methods: {
    // 父品牌改变
    handleBrandChange () {
      this.subBrandCode = ''
    },
    getBrandColor (index) {
      if (!this.brandSelectedMixing || !this.brandSelectedMixing[index]) return
      return this.brandSelectedMixing[index].split(',')[2]
    },
    // 添加混堆设计图
    addDesignDiagram () {
      if (!this.row || !this.column) {
        this.$message.warning('请先填写堆箱规格')
        return
      }
      if (!this.subBrandList.length) {
        this.getSubBrandList()
      }
      this.brandSelectedMixing = []
      this.designDialogVisible = true
    },
    // 修改混堆设计图
    modifyDesignDiagram () {
      console.log('modifyDesignDiagram')
      if (!this.subBrandList.length) {
        this.getSubBrandList()
      }
      this.brandSelectedMixing = this.brandSelectedMixing.slice(0)
      this.designDialogVisible = true
    },
    getSubBrandList () {
      if (!this.brandList.length) return
      let subBrandList = []
      this.brandList.forEach(item => {
        subBrandList = subBrandList.concat(item.subBrandList)
      })
      this.subBrandList = subBrandList
    },
    // 堆箱规格改变
    handleChangeStackSize () {
      // 混堆
      if (this.stackType === '02' && this.brandSelectedMixing.length) {
        this.brandSelectedMixing = []
      }
      // if (this.$refs['StackDesignConfig']) {
      //   this.$refs['StackDesignConfig'].brandSelectedMixing = []
      //   this.$refs['StackDesignConfig'].brandSelectedMixingOrigin = []
      // }
    },
    // 堆箱类型改变
    handleChangeStackType () {
      this.brandSelectedMixing = []
      // if (this.$refs['StackDesignConfig']) {
      //   this.$refs['StackDesignConfig'].brandSelectedMixing = []
      //   this.$refs['StackDesignConfig'].brandSelectedMixingOrigin = []
      // }
    },
    // 取消生成堆箱设计图
    handleCancelDesign () {
      this.designDialogVisible = false
    },
    // 确认生成堆箱设计图
    handleConfirmDesign (brandSelectedMixing) {
      this.designDialogVisible = false
      this.brandSelectedMixing = brandSelectedMixing
    },
    // 确认堆箱信息
    handleConfirm () {
      // this.checkData()
      if (this.checkData()) {
        let stackData = this.formatData()
        this.$emit('addStackInfo', stackData)
        this.resetData()
      }
    },
    // 取消
    handleCancel () {
      this.resetData()
      this.$emit('closeStackDialog')
      // this.dialogVisible = false
    },
    checkData () {
      let checkResult = true
      checkResult = this.checkStackCommon()
      if (checkResult && this.stackType === '01') {
        // 单品牌堆箱数据校验
        checkResult = this.checkStackSingle()
      }
      if (checkResult && this.stackType === '02') {
        // 混堆数据校验
        checkResult = this.checkStacMixing()
      }
      return checkResult
    },
    // 单品牌堆箱及混堆 通用数据校验
    checkStackCommon () {
      if (!this.row || !this.column) {
        this.$message.warning('请正确填写堆箱规格')
        return false
      }
      return true
    },
    // 单品牌堆箱数据校验
    checkStackSingle () {
      if (!this.brandCode) {
        this.$message.warning('请选择品牌')
        return false
      }
      if (!this.subBrandCode) {
        this.$message.warning('请选择子品牌')
        return false
      }
      return true
    },
    // 混堆数据校验
    checkStacMixing () {
      if (this.brandSelectedMixing.length !== Number(this.column)) {
        this.$message.warning('请配置混堆设计图')
        return false
      } else {
        return true
      }
    },
    // 格式化数据
    formatData () {
      let stackData
      if (this.stackType === '01') {
        stackData = this.formatStackSingleData()
      }
      if (this.stackType === '02') {
        stackData = this.formatStackMixingData()
      }
      return stackData
      // this.resetData()
    },
    // 格式化单品牌堆箱数据
    formatStackSingleData () {
      // let brands = this.brandCode.split(',')
      // let subBrands = this.subBrandCode.split(',')
      let data = {
        row: this.row,
        column: this.column,
        stackType: this.stackType,
        brandCode: this.brandCode,
        subBrandCode: this.subBrandCode,
        brandName: this.getBrandNameByCode(this.brandList, this.brandCode),
        subBrandName: this.getBrandNameByCode(this.getSubBrandListByCode, this.subBrandCode)
      }
      return data
    },
    // 根据code寻找对应品牌名称
    getBrandNameByCode (arr, code) {
      let obj = arr.find(item => {
        return item.abiBrandCode === code
      })
      return obj.abiBrandDesc
    },
    // 格式化混堆数据
    formatStackMixingData () {
      let data = {
        row: this.row,
        column: this.column,
        stackType: this.stackType,
        brandList: this.brandSelectedMixing.slice(0)
      }
      return data
    },
    // 重置数据
    resetData () {
      this.stackType = this.$options.data().stackType
      this.row = this.$options.data().row
      this.column = this.$options.data().column

      this.brandCode = this.$options.data().brandCode
      this.subBrandCode = this.$options.data().subBrandCode

      this.brandSelectedMixing = this.$options.data().brandSelectedMixing

      this.subBrandList = this.$options.data().subBrandList
      // this.$refs['StackDesignConfig'].brandSelectedMixing = []
      // this.$refs['StackDesignConfig'].brandSelectedMixingOrigin = []
    }
  }
}
</script>

<style lang="scss" scoped>
.stack-type,.stack-info {
  display: flex;
  justify-content: space-between;
}
.stack-size,.stack-brand {
  text-align: center;
}
.stack-radio {
  min-width: 120px;
}
.stack-brand {
  width: 150px;
}
.stack-title {
  width: 120px;
  font-weight: 600;
  text-align: center;
}
.stack-design {
  text-align: center;
  flex: 1 0 auto;
  .stack-title {
    width: 100%;
  }
  .design-thumbnail {
    display: flex;
    justify-content: center;
    overflow-x: auto;
    width: 100%;
    height: 100%;
    cursor: pointer;
    .design-thumbnail-column {
      display: inline-block;
    }
    .design-thumbnail-row {
      box-sizing: border-box;
      width: 25px;
      height: 25px;
      border: 1px solid #c0c4cc;
      border-radius: 3px;
    }
  }
}
</style>
